import * as Styles from './styles'

type ActionButtonsProps = {
  status: 'initial' | 'progress' | 'completed'
  handleClick: () => void
}

export const ActionButtons = ({ status, handleClick }: ActionButtonsProps) => {
  if (status === 'initial') {
    return (
      <Styles.InitialActionButtonsContainer>
        <Styles.InitialContinueButton onClick={handleClick}>
          Work with a coach
        </Styles.InitialContinueButton>
        <Styles.InitialCloseButton onClick={handleClick}>Not now</Styles.InitialCloseButton>
      </Styles.InitialActionButtonsContainer>
    )
  }

  return (
    <Styles.ProgressActionButtonsContainer>
      <Styles.ButtonContainer onClick={handleClick}>
        <Styles.ActionText>Button 1</Styles.ActionText>
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      </Styles.ButtonContainer>
      <Styles.ButtonContainer onClick={handleClick}>
        <Styles.ActionText>Button 2</Styles.ActionText>
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      </Styles.ButtonContainer>
    </Styles.ProgressActionButtonsContainer>
  )
}
